import React, { useState, useRef, useEffect } from 'react';
import Slider from 'react-slick';
import { motion, useInView } from 'framer-motion';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../CSS/Global.css';
import AccordianImg from '../Img/Laboratory-img (1).png';
import MainSliderImg1 from '../Img/Main_Img_Slider1.jpg';
import MainSliderImg2 from '../Img/Main_Img_Slider2.jpg';
import MainSliderImg3 from '../Img/Main_Img_Slider3.jpg';
import ArticleAwardSection from './ArticleAwardSection';
import WhyChoosePromed from './WhyChoosePromed';
import LogoCarousel from './LogoCarousel';
import Footer from './Footer';
import CitationTable from './CitationTable';
import NewsUpdates from './NewsUpdates';
import MainVideoImpact from '../Img/Main-Video-Impact.mp4'

const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow next-arrow" onClick={onClick}>
            <i className="fa-solid fa-chevron-right"></i>
        </div>
    );
};

const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow prev-arrow" onClick={onClick}>
            <i className="fa-solid fa-chevron-left"></i>
        </div>
    );
};

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.2
        }
    }
};

const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const AnimatedSection = ({ children, className = '' }) => {
    const ref = useRef();
    const isInView = useInView(ref, { once: true, margin: "-100px" });

    return (
        <motion.div
            ref={ref}
            className={className}
            variants={containerVariants}
            initial="hidden"
            animate={isInView ? "visible" : "hidden"}
        >
            {children}
        </motion.div>
    );
};

const Home = () => {
    const accordionData = [
        {
            title: "Pharmaceutical Sciences",
            content: `Pharmaceutics, Pharmacology, Pharmacognosy & Phytochemistry, Pharmaceutical Chemistry, Pharmaceutical Biotechnology, Pharmacy Practice, Pharmacogenomics, Medicinal Chemistry, Molecular Pharmacology, Novel Drug Delivery System, Nanotechnology, Analytical Chemistry, Organic Chemistry, Natural Chemistry, Polymer Sciences, Clinical Pharmacy`
        },
        {
            title: "Medical Sciences",
            content: `General Medicine, Public Health & Hygiene, Tropical Diseases, Endocrinology, Anatomy, Neurology, Dermatology, Orthopedics, Organ Transplantation, Oncology, Pathology, Hematology, Nephrology, Gynecology, Ophthalmology, Pediatrics, Radiology, Medical Biotechnology, Dentistry, Nursing, Cardiology, Respiratory Medicine`
        },
        {
            title: "Biological Sciences",
            content: `Biochemistry, Biotechnology, Genetics, Microbiology, Molecular Biology, Immunology, Biostatistics, Botany, Zoology, Cytology, Poultry Science, Fishery Science, Marine Biology, Wildlife Biology, Cell Biology, Environmental Sciences, Ecology & Environmental Biology, Veterinary Science`
        }
    ];


    const [activeIndex, setActiveIndex] = useState(0);
    const contentRefs = useRef([]);

    const toggleAccordion = (index) => {
        setActiveIndex(prev => (prev === index ? null : index));
    };

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
    };

    const paragraphTexts = [
        `IMPACT is an international, peer-reviewed journal that serves as a platform for researchers, scholars, and healthcare professionals to share their findings in pharmaceutical and medical sciences. Our mission is to foster the dissemination of original and high-quality research that contributes to the advancement of healthcare and the scientific community at large. We aim to inspire innovation, deepen understanding, and promote global collaboration in these critical fields.`,
        `The journal features a wide range of content including original research articles, comprehensive review papers, clinical Case Study, and evidence-based studies. Each submission undergoes a rigorous double-blind peer-review process to ensure integrity, credibility, and academic excellence. Our editorial board comprises experienced professionals from various disciplines who are committed to maintaining high standards of scientific publishing.`,
        `IMPACT values open-access principles, ensuring that research published with us is freely available to readers around the world without subscription barriers. We believe that accessible scientific knowledge drives progress, empowers healthcare providers, and ultimately benefits patients. By bridging academic research with real-world application, IMPACT stands at the forefront of the evolving landscape of pharmaceutical and medical science.`
    ];

    return (
        <>
            <AnimatedSection className="slider-container">
                {/* <Slider {...settings}>
                    {[MainSliderImg1, MainSliderImg2, MainSliderImg3].map((img, i) => (
                        <motion.div key={i} variants={itemVariants}>
                            <img src={img} alt={`Slider ${i + 1}`} className="slider-img" />
                        </motion.div>
                    ))}
                </Slider> */}

                <div className="main-video-slider">
                    <video autoPlay loop muted playsInline>
                        <source src={MainVideoImpact} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>

                </div>
            </AnimatedSection>

            <AnimatedSection className="welcome-section">
                <motion.h2 className="welcome-heading" variants={itemVariants}>
                    WELCOME TO <span className='impact-word-highlight'>IMPACT</span> - INTERNATIONAL MULTIDISCIPLINARY PHARMACEUTICAL AND CLINICAL TRENDS
                </motion.h2>

                <motion.div className="welcome-paragraphs" variants={containerVariants}>
                    {paragraphTexts.map((text, idx) => (
                        <motion.p key={idx} variants={itemVariants}>{text}</motion.p>
                    ))}
                </motion.div>
            </AnimatedSection>

            <AnimatedSection className="accordion-container">
                <motion.h2 className="accordion-heading" variants={itemVariants}>
                    We Cover the Following Areas
                </motion.h2>
                {accordionData.map((item, index) => (
                    <motion.div className="accordion-item" key={index} variants={itemVariants}>
                        <button
                            className={`accordion-title ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleAccordion(index)}
                        >
                            {item.title}
                            <i className={`fas fa-chevron-${activeIndex === index ? 'up' : 'down'}`}></i>
                        </button>
                        <div
                            ref={(el) => (contentRefs.current[index] = el)}
                            className={`accordion-content ${activeIndex === index ? 'open' : ''}`}
                            style={{
                                maxHeight: activeIndex === index
                                    ? `${contentRefs.current[index]?.scrollHeight}px`
                                    : '0px'
                            }}
                        >
                            <p>{item.content}</p>
                            <img src={AccordianImg} alt="Accordion Visual" />
                        </div>
                    </motion.div>
                ))}
            </AnimatedSection>

            <AnimatedSection>
                <ArticleAwardSection />
            </AnimatedSection>
            <AnimatedSection>
                <WhyChoosePromed />
            </AnimatedSection>
            <div className="citation-news-flex">
                {/* <div className="citation-table-flex">
                    <AnimatedSection>
                        <CitationTable />
                    </AnimatedSection>
                </div> */}
                <div className="news-updates-flex">
                    <AnimatedSection>
                        <NewsUpdates />
                    </AnimatedSection>
                </div>
            </div>
            {/* <AnimatedSection>
                <LogoCarousel />
            </AnimatedSection> */}
        </>
    );
};

export default Home;
